<template>
  <div>
    <VasionSchedulersPage title="Scheduled Reports" />
  </div>
</template>

<script>
export default {
  name: 'ScheduledReports',
  data: function () {
    return {
    }
  },
  computed: {
  },
  methods: { },
}
</script>

<style lang="scss" scoped>
</style>
